export class ModuleLoader {
  static loadedScripts = [];

  static load(src) {
    if (!this.loadedScripts.includes(src)) {
      this.loadedScripts.push(src);
      this.appendScriptToHead(src);
    }
  }

  static appendScriptToHead(src) {
    const script = createElement('script', {
      src: src,
      type: 'module',
    });

    document.head.appendChild(script);
  }
}

export const createElement = function (tagName, attributes = {}) {
  let element = document.createElement(tagName);
  Object.keys(attributes).forEach(function (attribute) {
    element.setAttribute(attribute, attributes[attribute]);
  });

  return element;
};
